import React, { useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Paperclip, Clock, Send, X } from 'lucide-react';

const apiUrl = process.env.REACT_APP_API_URL;

const CreateMailSchedule = () => {
  // const editorConfig = {
  //   plugins: [
  //     'fullscreen', 'image', 'lists', 'link',
  //     'table', 'code', 'emoticons', 'wordcount'
  //   ],
  //   toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright | bullist numlist | link image | fullscreen',
  // };
  const editorConfig = {
    //selector: "textarea",
    // mode:"textareas",
  //  theme: "modern",
    width: '98%',
    height: 400,
    plugins: [
      "advlist autolink lists link image charmap print preview hr anchor pagebreak",
      "searchreplace wordcount visualblocks visualchars code fullscreen ",
      "insertdatetime media nonbreaking save table contextmenu directionality ",
      "emoticons template paste textcolor  "
  ],
    toolbar1: "insertfile  undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
    toolbar2: "print preview media | forecolor backcolor emoticons",
    // image_advtab: true,
    // image_title: true,
    // paste_data_images: true,
    // readonly:false,
  };
  const BUId = sessionStorage.getItem("BUId");

  const [emailData, setEmailData] = useState({
    FromEmail: '',
    ToEmail: [''],
    CCEmail: [''],
    BCCEmail: [''],
    Body: '',
    AttachmentPath: [],
    ScheduledDate: null,
    Subject: '',
  });

  const [emailErrors, setEmailErrors] = useState({
    ToEmail: [],
    CCEmail: [],
    BCCEmail: []
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fromEmails, setFromEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState('');


  // Fetch FromEmails on mount
  useEffect(() => {
    const fetchFromEmails = async () => {
      try {
        const response = await fetch(`${apiUrl}/Mailer/GetFromMails?BUId=${BUId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch FromEmail options');
        }
        const data = await response.json();
        setFromEmails(data);
      } catch (error) {
        console.error('Error fetching FromEmail:', error);
      }
    };

    fetchFromEmails();

    // Cleanup TinyMCE on unmount
    return () => {
      window.tinymce?.remove();
    };
  }, []);

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return email && regex.test(email.trim());
  };

  const handleInputChange = (field, value, index = null) => {
    if (index !== null) {
      const updatedArray = [...emailData[field]];
      updatedArray[index] = value;

      if (field.includes('Email')) {
        const updatedErrors = [...(emailErrors[field] || [])];
        updatedErrors[index] = value.trim() !== '' && !validateEmail(value)
          ? 'Invalid email format'
          : '';

        setEmailErrors(prev => ({
          ...prev,
          [field]: updatedErrors
        }));
      }

      setEmailData(prev => ({
        ...prev,
        [field]: updatedArray,
      }));
    } else {
      setEmailData(prev => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleAddEmail = (field) => {
    setEmailData(prev => ({
      ...prev,
      [field]: [...prev[field], ''],
    }));

    setEmailErrors(prev => ({
      ...prev,
      [field]: [...(prev[field] || []), '']
    }));
  };

  const handleRemoveEmail = (field, index) => {
    setEmailData(prev => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index)
    }));

    setEmailErrors(prev => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index)
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 10 * 1024 * 1024; // 10MB limit
    
    const oversizedFiles = files.filter(file => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      alert('Some files exceed the size limit of 10MB');
      return;
    }
    
    setEmailData(prev => ({
      ...prev,
      AttachmentPath: files,
    }));
  };

  const removeFile = (indexToRemove) => {
    setEmailData(prev => ({
      ...prev,
      AttachmentPath: prev.AttachmentPath.filter((_, index) => index !== indexToRemove)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate From email
    if (!emailData.FromEmail || !validateEmail(emailData.FromEmail)) {
      alert('Please select a valid From email address');
      return;
    }

    // Validate To emails
    const validToEmails = emailData.ToEmail.filter(email => email && validateEmail(email));
    if (validToEmails.length === 0) {
      alert('Please add at least one valid email in To field');
      return;
    }

    // Validate CC emails
    if (emailData.CCEmail.some(email => email.trim() !== '')) {
      const invalidCCEmails = emailData.CCEmail.filter(email => email.trim() !== '' && !validateEmail(email));
      if (invalidCCEmails.length > 0) {
        alert('Please enter valid CC email addresses');
        return;
      }
    }

    // Validate BCC emails
    if (emailData.BCCEmail.some(email => email.trim() !== '')) {
      const invalidBCCEmails = emailData.BCCEmail.filter(email => email.trim() !== '' && !validateEmail(email));
      if (invalidBCCEmails.length > 0) {
        alert('Please enter valid BCC email addresses');
        return;
      }
    }

    // Validate required fields
    if (!emailData.Body || !emailData.ScheduledDate) {
      alert('Please fill in all required fields');
      return;
    }

    // Validate scheduled date
    const minimumDate = new Date();
    if (emailData.ScheduledDate <= minimumDate) {
      alert('Please select a future date and time');
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('BUId', BUId);
      formData.append('FromEmail', emailData.FromEmail);
      validToEmails.forEach(email => formData.append('ToEmail', email));
      emailData.CCEmail.filter(email => validateEmail(email)).forEach(email => formData.append('CCEmail', email));
      emailData.BCCEmail.filter(email => validateEmail(email)).forEach(email => formData.append('BCCEmail', email));
      formData.append('Body', emailData.Body);
      formData.append('Subject', emailData.Subject);
      formData.append('ScheduledDate', emailData.ScheduledDate.toISOString());

      if (emailData.AttachmentPath.length > 0) {
        emailData.AttachmentPath.forEach(file => formData.append('AttachmentFile', file));
      }

      const response = await fetch(`${apiUrl}/Mailer/SaveScheduledMails`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to schedule email');
      }

      alert('Email scheduled successfully!');

      // Reset form
      setEmailData({
        FromEmail: '',
        ToEmail: [''],
        CCEmail: [''],
        BCCEmail: [''],
        Body: '',
        AttachmentPath: [],
        ScheduledDate: null,
        Subject: '',
      });

      setSelectedEmail('');
      setEmailErrors({
        ToEmail: [],
        CCEmail: [],
        BCCEmail: [],
      });

    } catch (error) {
      console.error('Scheduling error:', error);
      alert(`Failed to schedule email: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderEmailInputs = (field, label, isRequired = false) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {isRequired && <span className="text-red-500">*</span>}
      </label>
      {emailData[field].map((email, index) => (
        <div key={index} className="flex items-center space-x-2 mb-2">
          <input
            type="email"
            value={email}
            onChange={(e) => handleInputChange(field, e.target.value, index)}
            placeholder={`${label} email`}
            required={isRequired}
            className={`w-full px-3 py-2 border ${emailErrors[field] && emailErrors[field][index] ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
          />
          {emailErrors[field] && emailErrors[field][index] && (
            <span className="text-red-500 text-sm">{emailErrors[field][index]}</span>
          )}
          {emailData[field].length > 1 && (
            <button
              type="button"
              onClick={() => handleRemoveEmail(field, index)}
              className="text-red-500"
            >
              <X size={20} />
            </button>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={() => handleAddEmail(field)}
        className="text-blue-500 mt-2"
      >
        Add another {label} Email
      </button>
    </div>
  );

  const handleChange = (event) => {
    const selected = event.target.value;
    setSelectedEmail(selected);
    setEmailData(prev => ({
      ...prev,
      FromEmail: selected
    }));
  };
  
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">SCHEDULE EMAIL</h1>
      </div>

      <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-xl">
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* From Email Dropdown */}
          <div className="grid grid-cols-1 gap-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              From Email <span className="text-red-500">*</span>
            </label>
            <select 
              id="fromEmail" 
              value={selectedEmail} 
              onChange={handleChange} 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select an Email</option>
              {fromEmails.map((emailObj, index) =>
                emailObj.fromEmails.map((email, emailIndex) => (
                  <option key={`${index}-${emailIndex}`} value={email}>
                    {email}
                  </option>
                ))
              )}
            </select>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {renderEmailInputs('ToEmail', 'To', true)}
            {renderEmailInputs('CCEmail', 'CC')}
            {renderEmailInputs('BCCEmail', 'BCC')}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <Paperclip className="inline mr-2" size={16} />
                Attachments
              </label>
              <input
                type="file"
                multiple
                onChange={handleFileChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {emailData.AttachmentPath.length > 0 && (
                <div className="mt-2">
                  <p className="text-sm font-medium mb-1">Selected Files:</p>
                  {emailData.AttachmentPath.map((file, index) => (
                    <div key={index} className="flex items-center justify-between bg-gray-100 p-2 rounded mb-1">
                      <span className="text-sm">{file.name}</span>
                      <button
                        type="button"
                        onClick={() => removeFile(index)}
                        className="text-red-500"
                      >
                        <X size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Clock className="inline mr-2" size={16} />
                  Schedule Date<span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={emailData.ScheduledDate}
                  onChange={(date) => handleInputChange('ScheduledDate', date)}
                  showTimeSelect
                  dateFormat="Pp"
                  placeholderText="Select date and time"
                  className={`w-full px-3 py-2 border ${
                    !emailData.ScheduledDate  
                  } rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  required
                  minDate={new Date()}
                  popperClassName="z-[9999]"
                  calendarClassName="shadow-lg"
                  // withPortal
                  portalId="root"
                />
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
            <input
              type="text"
              value={emailData.Subject}
              onChange={(e) => handleInputChange('Subject', e.target.value)}
              // placeholder="Subject (optional)"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Body</label>
            <Editor
              apiKey="vxlnf4hgzxborg4poyt2sqrxak5984rmbp9rt8xr1elsbl3n"
              value={emailData.Body || ''}
              onEditorChange={(content) => handleInputChange('Body', content)}
              init={{
                ...editorConfig,
                placeholder: 'Compose your email...',
                height: 300,
              }}
            />
          </div> */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Body <span className="text-red-500">*</span>
            </label>
            <Editor
              value={emailData.Body}
              init={editorConfig}
              onEditorChange={(content) => handleInputChange('Body', content)}
            />
                  {/* <Editor
        initialValue={editorContent}
        init={editorConfig}
        onEditorChange={handleEditorChange}
      /> */}
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full flex items-center justify-center px-4 py-3 rounded-md text-white font-semibold ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
          >
            {isSubmitting ? 'Scheduling...' : 'Schedule Email'}
            <Send className="ml-2" size={18} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateMailSchedule;
